import script from "./Navi.vue?vue&type=script&lang=ts&setup=true"
export * from "./Navi.vue?vue&type=script&lang=ts&setup=true"

import "./Navi.vue?vue&type=style&index=0&id=582bb170&lang=scss"

const __exports__ = script;

export default __exports__